import { isValidSize } from '../helpers';

export default {
  props: {
    size: {
      require: false,
      type: [String, Number],
      default: '16',
      description: 'Size in Number or Units',
      validator: val => isValidSize(val),
    }
  }
};
